import React from "react";
import { UsersList } from "./UsersList";
import { CreateUserForm } from "./CreateUserForm";
import { Modal } from "../../../components/Modal";
import ControlledToggle from "../../../../../components/Form/ControlledToggle";
import ControlledQuickSearch from "../../../../../components/QuickSearch/ControlledQuickSearch";

import type { User } from "../../shared/types/models";

export interface UsersViewProps {
  users?: User[];
  isLoadingUsers: boolean;
  navigateToUserDetails: (user: User) => void;
  showActiveOnly: boolean;
  onToggleChange: (checked: boolean) => void;
  searchTerm: string;
  debouncedSearchTerm: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const UsersView: React.FC<UsersViewProps> = (props) => {
  const [isCreateUserModalOpen, setIsCreateUserModalOpen] =
    React.useState<boolean>(false);

  function handleOpenCreateUserModalButtonClick(): void {
    setIsCreateUserModalOpen(true);
  }

  function handleCreateUserModalCloseAction(): void {
    setIsCreateUserModalOpen(false);
  }

  function handleCreateUserFormCancelButtonClick(): void {
    setIsCreateUserModalOpen(false);
  }

  function handleCreateUserFormSubmitSuccess(): void {
    setIsCreateUserModalOpen(false);
  }

  function handleUserRowClick(user: User): void {
    props.navigateToUserDetails(user);
  }

  return (
    <>
      <div className="max-w-7xl mx-auto px-4">
        <main className="max-w-5xl mx-auto py-6">
          <div className="flex justify-between items-center">
            <span className="font-semibold text-xl text-gray-700 dark:text-gray-200">Users</span>
            <div className="flex items-center gap-4">
              <ControlledToggle
                checked={props.showActiveOnly}
                onChange={props.onToggleChange}
                label="Active only"
              />
              <button
                type="button"
                onClick={handleOpenCreateUserModalButtonClick}
                className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 dark:text-blue-100 bg-blue-100 dark:bg-blue-900 disabled:text-blue-500 dark:disabled:text-blue-400 disabled:bg-blue-50 dark:disabled:bg-blue-900 disabled:cursor-not-allowed border border-transparent rounded-md hover:bg-blue-200 dark:hover:bg-blue-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
              >
                Add
              </button>
            </div>
          </div>
          <div className="mt-4 mb-4">
            <div className="max-w-md">
              <ControlledQuickSearch
                title="Search Users"
                handleChange={props.onSearchChange}
                placeholder="Search by name or email..."
                value={props.searchTerm}
              />
            </div>
          </div>
          <div className="mt-3">
            <UsersList 
              users={props.isLoadingUsers ? [] : props.users ?? []} 
              handleRowClick={handleUserRowClick}
              searchTerm={props.debouncedSearchTerm}
            />
          </div>
        </main>
      </div>
      <Modal isOpen={isCreateUserModalOpen} handleCloseAction={handleCreateUserModalCloseAction}>
        {() => <CreateUserForm handleCancelButtonClick={handleCreateUserFormCancelButtonClick} handleFormSubmitSuccess={handleCreateUserFormSubmitSuccess} />}
      </Modal>
    </>
  )
};
